import { observer } from "mobx-react";
import { useEffect } from "react";
import { initSignDocumentPageAction, prepareState } from "./signDocumentDomain";
import { SignDocumentPageView } from "./signingComponents";
import { fromQueryString } from "../utils/queryParams";
import { useLanguage, useRootStore } from "../stores/RootStoreContext";
import { useAppBar } from "../appBar/useAppBar";

const SignDocumentPage = observer(() => {
  const location = useRootStore().location;
  const { signDocument, messageStore, dispatch } = useRootStore();
  const appBar = useAppBar();
  const lang = useLanguage();
  useEffect(() => {
    dispatch(initSignDocumentPageAction(fromQueryString(location.search).ref));
  }, [dispatch, location.search]);
  return (
    <SignDocumentPageView
      state={prepareState(dispatch, signDocument, appBar, lang)}
      alertStore={messageStore}
    />
  );
});

export default SignDocumentPage;
